import React, { Fragment } from "react";
import moment from "moment";
import shortid from "shortid";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import {
  saveBrand,
  saveUnreadSupportMessages,
  saveUnreadMessagesFromSuper,
} from "../../redux/actions";
import Header from "../../components/Header";
import NewPoll from "../../components/NewPoll";
import NewOffer from "../../components/NewOffer";
import AddPost from "../Feeds/components/AddPost";
import BroadcastOfferModal from "../Perks/components/BroadcastOfferModal";
import AddCompetiton from "../Competitions/components/AddCompetition";
import AddEventModal from "../Event/AddEventModal";
import AddGoal from "../GamificationGoals/components/AddGoal";
import AddTopicModal from "../AdventPlanner/components/AddTopicModal";
import AddTaskModal from "../AdventPlanner/components/AddTaskModal";
import AddVideoModal from "../AdventPlanner/components/AddVideoModal";
import Firebase from "../../firebasehelper";
import HotContent from "./components/HotContent";

import "./index.css";
import pollsImg from "../../assets/media/analytics_icons/user_reviews.png";
import feedsImg from "../../assets/media/Topic.png";
import offerImg from "../../assets/media/percent-coin.png";
import gameImg from "../../assets/media/competition.png";
import plugImg from "../../assets/media/plus.png";
import checkImg from "../../assets/media/check.png";
import fireImg from "../../assets/media/fire.png";
import articleImg from "../../assets/media/magazine.png";
import eventImg from "../../assets/media/ticket.png";
import goalImg from "../../assets/media/goal.png";
import topicImg from "../../assets/media/xmas/topic.png";
import taskImg from "../../assets/media/xmas/task.png";
import videoImg from "../../assets/media/xmas/video.png";

import { TerritoryOptions } from "../../Constants/retailer";
import { getYoutubeId } from "../../Utils/utils";
import { IMAGE_UPLOAD, VIDEO_UPLOAD, YOUTUBE_URL } from "../../Constants/types";
import { idealTextColor } from "../../functions";
const $ = window.$;
const UPLOADING_VIDEO = "Uploading video";
const UPLOADING_IMAGE = "Uploading image...";
class Planner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: false,
      loading_script: "",
      postData: null,
      posts: [],
      users: [],
      polls: [],
      events: [],
      articles: [],
      competitions: [],
      retailers: [],
      offers: [],
      goals: [],
      topics: [],
      tasks: [],
      videos: [],
      selectedWeek: 0,
      selectedDate: null,
      hotTopics: [],
      current_hotTopic: null,
      currentPlanType: "",
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      // i am in sub brand
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        brand_data.id = brand;
        this.props.dispatch(saveBrand(brand_data));
        this.setState(
          {
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            permissions: brand_data.permissions,
            territory: brand_data.territory || TerritoryOptions[0],
            hex: brand_data.hex,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          },
          () => {
            this.setState({ polls: brand_data.polls || [] });
            Firebase.getArticlesByBrand(brand_data.name, (articles) =>
              this.setState({ articles })
            );
            Firebase.getAllPosts(brand_data.name, this.subscribePosts);
            Firebase.getAllCompetitions(
              brand_data.name,
              this.subscribeCompetitions
            );
            // Firebase.getAllUsersInBrand
            Firebase.getAllBrandOffers(brand_data.name, this.subscribeOffers);
            Firebase.getAllRetailers(this.subscribeRetailers);
            Firebase.getAllEvents(brand_data.name, this.subscribeEvents);
            Firebase.getAllHotTopics(brand_data.name, this.subscribeHotTopics);
            Firebase.getAllFeaturedContent(
              brand_data.name,
              this.subscribeHotVideos
            );
            Firebase.getGoalsByBrand(brand_data.name, this.subscribeGoals);
            Firebase.getAllDailyTopics(brand_data.name, this.subscribeTopics);
            Firebase.getAllDailyTasks(brand_data.name, this.subscribeTasks);
            Firebase.getAllDailyVideos(brand_data.name, this.subscribeVideos);
            Firebase.getUnReadMessages(
              brand_data.name,
              this.subscribeUnreadMessages
            );
            Firebase.getBrandUnReadMessages(
              brand,
              this.subscribeBrandUnreadMessages
            );
          }
        );
      });
    }
  }

  subscribeCompetitions = (competitions) => {
    this.setState({ competitions });
  };

  subscribeEvents = (events) => {
    let Ev = events.filter((event) => event.time);
    this.setState({ events: Ev });
  };

  subscribePosts = (posts) => {
    posts.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
    this.setState({ posts, loading: false });
  };

  subscribeGoals = (goals) => {
    console.log("goals", goals);
    goals.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
    this.setState({ goals, loading: false });
  };

  subscribeTopics = (topics) => {
    console.log("topics", topics);
    topics.sort((a, b) => b.time.seconds - a.time.seconds);
    this.setState({ topics, loading: false });
  };

  subscribeTasks = (tasks) => {
    console.log("tasks", tasks);
    tasks.sort((a, b) => b.time.seconds - a.time.seconds);
    this.setState({ tasks, loading: false });
  };

  subscribeVideos = (videos) => {
    console.log("videos", videos);
    videos.sort((a, b) => b.time.seconds - a.time.seconds);
    this.setState({ videos, loading: false });
  };

  subscribeUsers = (users) => {
    this.setState({ users });
  };

  subscribeOffers = (offers) => {
    this.setState({ offers: offers.filter((obj) => !obj.newadvent) });
  };
  subscribeHotTopics = (hotTopics) => {
    this.setState({ hotTopics }, this.getHotTopic);
  };
  subscribeHotVideos = (hotVideos) => {
    this.setState({ hotVideos }, this.getHotVideo);
  };
  subscribeRetailers = (retailers) => {
    this.setState({
      retailers: Object.values(retailers).filter(
        (obj) => (obj.territory || TerritoryOptions[0]) === this.state.territory
      ),
    });
  };
  subscribeUnreadMessages = (unreads) => {
    this.props.dispatch(saveUnreadSupportMessages(unreads));
  };
  subscribeBrandUnreadMessages = (unreads) => {
    const unreadsFromSuper = [];
    Object.keys(unreads).map((ticket_id) => {
      unreadsFromSuper.push({
        id: ticket_id,
        ...unreads[ticket_id],
      });
    });
    this.props.dispatch(saveUnreadMessagesFromSuper(unreadsFromSuper));
  };

  showPlans = (type = "feed") => {
    const { current_hotTopic, current_hotVideo } = this.state;
    let PlanItem = ({ date }) => {
      let image = null,
        youtube_video = null,
        video = null;
      if (type === "hot") {
        if (current_hotTopic) image = current_hotTopic.media_url;
      } else if (type === "hot-video") {
        if (current_hotVideo) video = current_hotVideo.media_url;
      } else if (type === "feed") {
        const post = this.state.posts.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image =
          post && post.media_type === IMAGE_UPLOAD ? post.media_url : null;
        youtube_video =
          post && post.media_type === YOUTUBE_URL ? post.media_url : null;
        video =
          post && post.media_type === VIDEO_UPLOAD ? post.media_url : null;
      } else if (type === "poll") {
        const poll = this.state.polls.find(
          (obj) =>
            obj &&
            obj.scheduledDate &&
            date.isSame(new Date(obj.scheduledDate), "day")
        );
        image = poll ? poll.question_img : null;
      } else if (type === "competition") {
        const competition = this.state.competitions.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image = competition ? competition.img_url : null;
      } else if (type === "offer") {
        const offer = this.state.offers.find((obj) => {
          return date.isSame(new Date(obj.startTime), "day");
        });
        const retailer = this.state.retailers.find(
          (obj) => offer && obj.retailerName === offer.retailer
        );
        image = retailer ? retailer.logo : offer ? offer.perkLogo : null;
      } else if (type === "event") {
        const event = this.state.events.find((obj) =>
          date.isSame(moment(obj.time).toDate(), "day")
        );
        image =
          event && event.media_type === IMAGE_UPLOAD ? event.media_url : null;
        youtube_video =
          event && event.media_type === YOUTUBE_URL ? event.media_url : null;
        video =
          event && event.media_type === VIDEO_UPLOAD ? event.media_url : null;
      } else if (type === "goals") {
        const goal = this.state.goals.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image =
          goal && goal.media_type === IMAGE_UPLOAD ? goal.media_url : null;
        youtube_video =
          goal && goal.media_type === YOUTUBE_URL ? goal.media_url : null;
        video =
          goal && goal.media_type === VIDEO_UPLOAD ? goal.media_url : null;
      } else if (type === "topic") {
        const topic = this.state.topics.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
        image =
          topic && topic.media_type === IMAGE_UPLOAD ? topic.media_url : null;
        youtube_video =
          topic && topic.media_type === YOUTUBE_URL ? topic.media_url : null;
        video =
          topic && topic.media_type === VIDEO_UPLOAD ? topic.media_url : null;
      } else if (type === "task") {
        const task = this.state.tasks.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
        image =
          task && task.media_type === IMAGE_UPLOAD ? task.media_url : null;
        youtube_video =
          task && task.media_type === YOUTUBE_URL ? task.media_url : null;
        video =
          task && task.media_type === VIDEO_UPLOAD ? task.media_url : null;
      } else if (type === "video") {
        const videoObj = this.state.videos.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
        image =
          videoObj && videoObj.media_type === IMAGE_UPLOAD
            ? videoObj.media_url
            : null;
        youtube_video =
          videoObj && videoObj.media_type === YOUTUBE_URL
            ? videoObj.media_url
            : null;
        video =
          videoObj && videoObj.media_type === VIDEO_UPLOAD
            ? videoObj.media_url
            : null;
      }
      if (image) {
        return (
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="calendar-item"
          >
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (video) {
        return (
          <div className="calendar-item">
            <ReactPlayer
              url={video}
              width="100%"
              height="100%"
              controls={true}
            />
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (youtube_video) {
        return (
          <div className="calendar-item">
            <iframe
              title="video"
              width="100%"
              height="100%"
              src={`//www.youtube.com/embed/${getYoutubeId(
                youtube_video
              )}?modestbranding=1&showinfo=0`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      const isPastDay = date.isBefore(moment(), "day");
      return (
        <button
          className="add-plan-btn"
          type="button"
          data-toggle="modal"
          data-target={
            type === "topic" || type === "task" || type === "video"
              ? `#add_daily_${type}_modal`
              : `#add_${type}_modal`
          }
          onClick={() => {
            this.setState({ selectedDate: date });
          }}
          disabled={isPastDay}
          onPointerEnter={() => this.setState({ currentPlanType: type })}
          onPointerLeave={() => this.setState({ currentPlanType: "" })}
        >
          {!isPastDay && (
            <img src={plugImg} className="default-item" alt="default" />
          )}
        </button>
      );
    };

    return [0, 1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="plan">
        <PlanItem date={this.getWeekDate(i)} />
      </div>
    ));
  };

  getWeekDate = (i) => {
    if (moment().isSame(moment().startOf("week"))) {
      return moment().add("days", this.state.selectedWeek * 7 + i - 6);
    }
    return moment()
      .startOf("week")
      .add("days", this.state.selectedWeek * 7 + i + 1);
  };
  getHotTopic = () => {
    const { hotTopics } = this.state;
    const week_start = this.getWeekDate(0);
    let matched_hotTopic = hotTopics.find((hotTopic) => {
      const hotTopic_date = hotTopic.starting_monday.toDate();
      if (week_start.isSame(hotTopic_date, "day")) {
        return true;
      }
    });
    this.setState({ current_hotTopic: matched_hotTopic });
  };
  getHotVideo = () => {
    const { hotVideos } = this.state;
    const week_start = this.getWeekDate(0);
    let matched_hotVideo = hotVideos.find((hotVideo) => {
      const hotVideo_date = hotVideo.starting_monday.toDate();
      if (week_start.isSame(hotVideo_date, "day")) {
        return true;
      }
    });
    this.setState({ current_hotVideo: matched_hotVideo });
  };
  showDays = () => {
    const weekDays = moment.weekdaysShort();
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = this.getWeekDate(index);
      if (date.isSameOrAfter(moment(), "day"))
        return (
          <p key={index} style={{ width: "9%" }}>
            {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
          </p>
        );
      return <p key={index} style={{ width: "9%" }}></p>;
    });
  };

  showWeekBar = () => {
    const { selectedWeek } = this.state;
    return (
      <div className="week-bar">
        <p style={{ fontWeight: 700 }}>Content & Engagement Planner</p>
        {[0, 1, 2, 3, 4].map((obj) => (
          <button
            key={obj}
            className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
            onClick={() => {
              this.setState({ selectedWeek: obj }, this.getHotTopic);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
    );
  };

  showHotContent = () => {
    const { current_hotTopic, current_hotVideo, brand_name, hex } = this.state;
    return (
      <div className="hot-content">
        <div className="_header" style={{ backgroundColor: "#FEE17D" }}>
          <img src={fireImg} alt="fire" />
          <p>Hot</p>
        </div>
        {current_hotTopic && (
          <HotContent
            {...current_hotTopic}
            brand_name={brand_name}
            type="hotTopic"
            hex={hex}
          />
        )}
        {current_hotVideo && (
          <HotContent
            {...current_hotVideo}
            brand_name={brand_name}
            type="hotVideo"
            hex={hex}
          />
        )}
      </div>
    );
  };
  postOffer = async (data) => {
    const { retailer, attentionGrabber, postNow, scheduledDate, hot_topic } =
      data;
    console.log("data", data);
    // const { brand_name } = this.state;
    // const offer = {
    //   id: shortid.generate(),
    //   retailer: retailer.value,
    //   hot_topic: hot_topic,
    //   attentionGrabber,
    //   created_at: moment().valueOf(),
    //   postNow,
    //   scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
    // };
    // let res = await Firebase.addBrandOffer(brand_name, offer);

    // let schedule_data = {
    //   id: res.id,
    //   type: "offer",
    //   time: scheduledDate.valueOf(),
    //   brand_name: brand_name,
    // };
    // let schedule_res = await Firebase.registerSchedule(schedule_data);

    // $("#add_offer_modal").modal("hide");
  };

  postPoll = async (data) => {
    const {
      answers,
      question,
      media_type,
      media_url,
      postNow,
      scheduledDate,
      hot_topic,
    } = data;
    const { brand_name, brand } = this.state;

    const isPostable =
      question &&
      media_type &&
      media_url &&
      !answers.find((answer) => !answer.text);

    if (isPostable) {
      const poll = {
        id: shortid.generate(),
        hot_topic,
        answers,
        question,
        media_type,
        media_url,
        // question_img,
        created_at: moment().valueOf(),
        postNow,
        scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
      };
      Firebase.updateBrandDataById(brand, {
        polls: [...this.state.polls, poll],
      });
      if (!postNow) {
        let schedule_data = {
          id: poll.id,
          type: "poll",
          time: poll.scheduledDate,
          brand_name: brand_name,
          brand_id: brand,
        };
        let schedule_res = await Firebase.registerSchedule(schedule_data);
      }
      $("#add_poll_modal").modal("hide");
    } else {
      alert("please fill all required fields");
      return "empty_fields";
    }
  };
  /*
  All func related to posting feed
  */
  handlePost = async (postData) => {
    const uid = localStorage.getItem("uid");
    const { postNow, scheduledDate } = postData;
    const { brand_name, username } = this.state;
    let res = await Firebase.addPost(
      { ...postData, uid, username, scheduledDate: scheduledDate.valueOf() },
      brand_name
    );
    if (!postNow) {
      let schedule_data = {
        id: res.id,
        type: "feed",
        time: scheduledDate.valueOf(),
        brand_name: brand_name,
      };
      await Firebase.registerSchedule(schedule_data);
    }
  };

  postCompetition = async (
    title,
    image_content,
    content,
    task,
    postNow,
    scheduledDate,
    runUntil,
    hot_topic
  ) => {
    const { brand_name, username } = this.state;
    let folder = "posters/" + brand_name;
    let image_url = await Firebase.uploadImage(
      image_content,
      `competition_${moment().valueOf()}`,
      folder
    );

    // let avatar_url= "https://img.icons8.com/clouds/2x/user.png";
    let avatar_url = "";

    let post = {
      title,
      image_url,
      uid: localStorage.getItem("uid"),
      content,
      username,
      avatar_url,
      task,
      postNow,
      scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
      runUntil: runUntil.valueOf(),
      hot_topic,
    };
    let res = await Firebase.addCompetition(post, brand_name);
    if (!postNow) {
      let schedule_data = {
        id: res.id,
        type: "competition",
        time: scheduledDate.valueOf(),
        brand_name: brand_name,
      };
      let schedule_res = await Firebase.registerSchedule(schedule_data);
    }
  };
  createEvent = async (payload) => {
    const {
      img_content,
      title,
      address,
      token,
      type,
      description,
      selectedDate,
    } = payload;
    let { brand_name } = this.state;
    let folder = "events/" + brand_name;
    this.setState({ loading: true });
    let image_url = await Firebase.uploadImage(img_content, title, folder);
    let event = {
      title,
      type,
      address,
      description,
      image_url,
      token,
      time: selectedDate.toDate(),
    };

    Firebase.addEvent(event, brand_name).then((res) => {
      this.setState({ loading: false });
    });
  };
  handleCreateGoal = async (goalData, mediaContent) => {
    const { contentType, title, scheduledDate } = goalData;
    const { brand_name } = this.state;
    let folder = "goals/" + brand_name;
    goalData.scheduledDate = scheduledDate.valueOf();
    this.setState({ goalData }, () =>
      this.upload(contentType, mediaContent, title, folder)
    );
  };
  createPlan = (type) => (content) => {
    content.time = this.state.selectedDate.toDate();
    if (type === "topic")
      Firebase.addDailyTopic(content, this.state.brand_name);
    if (type === "task") {
      Firebase.addDailyTask(content, this.state.brand_name);
    }
    if (type === "video") {
      Firebase.addDailyVideo(content, this.state.brand_name);
    }
  };
  renderNewPollDialog = (brand_name) => (
    <div
      className="modal fade"
      id="add_poll_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog add-new-poll-modal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a new poll</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <NewPoll
              selectedDate={this.state.selectedDate}
              brand_name={brand_name}
              onAdd={this.postPoll}
            />
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );

  renderNewOfferDialog = (brand_name) => (
    <div
      className="modal fade"
      id="add_offer_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog add-new-offer-modal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Schedule an offer</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <NewOffer
              selectedDate={this.state.selectedDate}
              brand_name={brand_name}
              retailers={this.state.retailers}
              onAdd={this.postOffer}
            />
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
  upload = async (contentType, mediaContent, title, uploadFolder) => {
    if (contentType === IMAGE_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ loading: false });
      this.postGoal(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      this.setState({
        uploadTask,
        loading: true,
        loading_script: UPLOADING_VIDEO,
      });
      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        this.handleDownloadURL
      );
    } else if (contentType === YOUTUBE_URL) {
      this.postGoal(mediaContent);
    }
  };
  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    this.setState({ loading_script: UPLOADING_VIDEO + " " + progress + "%" });
  };

  handleUploadError = (error) => {
    this.setState({ loading: false, loading_script: "" });
  };

  handleDownloadURL = () => {
    const { uploadTask } = this.state;
    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
      this.setState({ loading: false, loading_script: "" });
      this.postGoal(downloadURL);
    });
  };
  postGoal = async (downloadUrl) => {
    const { goalData, brand_name } = this.state;
    const goal = {
      ...goalData,
      media_url: downloadUrl,
    };
    await Firebase.addGoal(goal, brand_name);
  };
  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      loading_script,
      brand_name,
      territory,
      articles,
      currentPlanType,
      hex,
      permissions,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="planner-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
              <p>{loading_script}</p>
            </div>
          )}
          {this.showWeekBar()}
          {/* {(current_hotTopic || current_hotVideo) && this.showHotContent()} */}
          <div className="calendar">
            <div className="date">
              <p style={{ width: "4%" }}>Content</p>
              {this.showDays()}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "article" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "feed"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={articleImg} />
                <p>Articles</p>
              </div>
              {this.showPlans("article")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor: currentPlanType === "hot" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "feed"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={fireImg} />
                <p>Topic Feed</p>
              </div>
              {this.showPlans("hot")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "hot-video" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "feed"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={fireImg} />
                <p>Video</p>
              </div>
              {this.showPlans("hot-video")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor: currentPlanType === "feed" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "feed"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={feedsImg} />
                <p>News Feeds</p>
              </div>
              {this.showPlans("feed")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor: currentPlanType === "poll" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "poll"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={pollsImg} />
                <p>Polls</p>
              </div>
              {this.showPlans("poll")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "offer" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "offer"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={offerImg} alt="offer" />
                <p>Offer</p>
              </div>
              {this.showPlans("offer")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "competition" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "competition"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={gameImg} />
                <p>Games</p>
              </div>
              {this.showPlans("competition")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "event" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "event"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={eventImg} />
                <p>Events</p>
              </div>
              {this.showPlans("event")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor: currentPlanType === "goal" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "goal"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={goalImg} />
                <p>Goals</p>
              </div>
              {this.showPlans("goal")}
            </div>
            {permissions && permissions.hotTopic && (
              <div className="plan_row">
                <div
                  className="plan_header"
                  style={{
                    backgroundColor:
                      currentPlanType === "topic" ? hex : "#ffffff",
                    borderRadius: "8px",
                    color:
                      currentPlanType === "topic"
                        ? idealTextColor(hex)
                        : "#000000",
                  }}
                >
                  <img src={topicImg} alt="Topic" />
                  <p>Topic</p>
                </div>
                {this.showPlans("topic")}
              </div>
            )}
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor: currentPlanType === "task" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "task"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={taskImg} alt="Task" />
                <p>Task</p>
              </div>
              {this.showPlans("task")}
            </div>
            <div className="plan_row">
              <div
                className="plan_header"
                style={{
                  backgroundColor:
                    currentPlanType === "video" ? hex : "#ffffff",
                  borderRadius: "8px",
                  color:
                    currentPlanType === "video"
                      ? idealTextColor(hex)
                      : "#000000",
                }}
              >
                <img src={videoImg} alt="Video" />
                <p>Video</p>
              </div>
              {this.showPlans("video")}
            </div>
          </div>
          {this.renderNewPollDialog(brand_name)}
          {/* {this.renderNewOfferDialog(brand_name)} */}
          <AddPost
            selectedDate={this.state.selectedDate}
            brand_name={brand_name}
            onAdd={this.handlePost}
          />
          <BroadcastOfferModal
            selectedDate={this.state.selectedDate}
            onAdd={this.postOffer}
          />
          <AddCompetiton
            selectedDate={this.state.selectedDate}
            brand_name={brand_name}
            onAdd={this.postCompetition}
          />
          <AddEventModal
            selectedDate={this.state.selectedDate}
            createEvent={this.createEvent}
            territory={territory}
            articles={articles}
          />
          <AddGoal
            selectedDate={this.state.selectedDate}
            onAdd={this.handleCreateGoal}
          />
          <AddTopicModal onCreate={this.createPlan("topic")} />
          <AddTaskModal onCreate={this.createPlan("task")} />
          <AddVideoModal onCreate={this.createPlan("video")} />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Planner);



// WEBPACK FOOTER //
// ./src/screens/Planner/index.js